export interface PortfolioItem {
  slug: string;
  title: string;
  description: string;
}

export const projects: PortfolioItem[] = [
  {
    slug: 'wmt-transitions-bulk-upload-solution',
    title: 'Streamlining Document Handling - WMT Transitions',
    description: `We built a robust application for WMT Transitions using .NET and React TypeScript, hosted on Azure, that:

- Bulk uploads CSV files
- Matches documents to household numbers
- Stores documents in SharePoint
- Sends them out for signing with DocuSign

**Key Technologies**: .NET, React TypeScript, Material UI, Azure SQL, DocuSign API, SharePoint API

**Impact**: Streamlined a previously manual process into a seamless digital workflow, significantly improving turnaround time and accuracy.`,
  },
  {
    slug: 'designing-caii365-org',
    title: 'Designing caii365.org - A Non-Profit Art And Ecommerce Site',
    description: `We created a stunning nonprofit site for Community Arts Initiative 365 using our drag-and-drop builder.

- Integrated e-commerce functionality
- Showcased artwork and events
- Built-in donation and membership tools

**Tech Stack**: Custom builder (with Shopify compatibility)

**Client Feedback**: Ted was thrilled with the outcome, stating it exceeded his expectations for a community-based site.`,
  },
  {
    slug: 'custom-squarespace-product-table-for-saint-technologies',
    title: 'Custom Squarespace Product Table For Saint Technologies',
    description: `Developed a dynamic product table on Squarespace for Saint Technologies.

- Connected to Google Sheets for backend updates
- Seamlessly integrated into Squarespace
- Editable product data without site access

**Tech Used**: JavaScript, Squarespace Custom Code, Google Sheets API

**Benefit**: Non-technical users can update product listings live by simply editing a Google Sheet.`,
  },
  {
    slug: 'dandalaw-com-migration-from-scorpion-cms-to-wordpress',
    title: 'DandaLaw.com Migration From Scorpion CMS To Wordpress',
    description: `We migrated 1400+ pages from Scorpion CMS to WordPress for DandaLaw.com.

- Automated bulk page conversions
- Rebuilt structure with Elementor
- Gave full customization control back to the client

**Timeframe**: 8 weeks  
**Tools**: WordPress, Elementor, Custom Scripts

**Result**: A scalable, client-owned website with full design and SEO control.`,
  },
  {
    slug: 'mark-924-ministries-site',
    title: 'Empowering Faith Through Design: Mark 924 Ministries Website Creation',
    description: `In a world where digital presence is crucial for outreach and connection, the project for Mark 924 Ministries stood out as a beacon of light. Our mission was to design a Christian life coach website that not only served as an informational hub but also as a source of inspiration and solace.

### Conceptualizing Faith and Functionality
Working with Logan Stamm, we aimed to encapsulate the essence of Mark 924 Ministries within every pixel and code snippet. Using WordPress and the Divi theme, we created an inviting, user-friendly site.

### Designing for Engagement
- **Inspirational Design**: Warm, mission-aligned imagery and typography
- **Responsive Layout**: Accessible across all devices
- **Content Strategy**: SEO-optimized, faith-based content

### Impact
The site became a sanctuary for seekers, offering blog posts, guides, and resources. Feedback praised its clarity, mission alignment, and ease of navigation.

### Reflection
This project highlights our ability to create deeply resonant digital experiences that connect and uplift the target audience.`,
  },
  {
    slug: 'optinmonster-sailthru-plugin',
    title: 'Seamless Marketing Automation: OptinMonster to Sailthru Integration',
    description: `Courier Newsroom needed a bridge between OptinMonster and Sailthru to enhance their lead gen and email marketing workflows. We delivered a custom WordPress plugin to fill this gap.

### The Challenge
No native integration existed between the two platforms. They needed a reliable, real-time sync of user form data.

### Our Solution
- **Custom Plugin**: Built from scratch to handle API auth and data mapping
- **Real-Time Sync**: Instantly sent captured leads to Sailthru
- **Configurable**: Admins could set rules for behavior and targeting

### Results
This solution unlocked highly personalized email campaigns, improved segmentation, and helped scale their marketing efforts efficiently.`,
  },
  {
    slug: 'the-learning-kitchen-calendar',
    title: 'Enhancing Class Booking: Scraping + Front-End for The Learning Kitchen',
    description: `The Learning Kitchen needed to present accurate class availability, but their POS system lacked an API.

### Our Approach
We built a .NET console app to scrape their data every 10 minutes and store it in Azure SQL.

### Front-End Experience
Using React and Material UI, we developed:
- A real-time class calendar
- Visual indicators for sold-out classes
- Hover actions to register or waitlist

### Outcomes
Customers now browse classes confidently, and the kitchen receives fewer support calls about availability. The UI was praised for clarity and speed.`,
  },
  {
    slug: 'automated-data-pipeline',
    title: 'Empowering Analytics: Automated Data Pipeline for Reporting',
    description: `To eliminate delays in reporting, we built a .NET app that transfers fresh data into analytics platforms.

### Key Features
- **Scheduled Data Transfers**: Reduced dependency on manual exports
- **Secure Pipelines**: Protected PII and sensitive business data
- **Analytics-Ready Format**: Structured for easy analysis

### Result
The analytics team could access real-time data with minimal delay, leading to better decision-making and reduced operational lag.

This project showcased our strength in automation, secure data management, and team empowerment through technology.`,
  },
  {
    slug: 'scalable-list-scrubbing-service',
    title: 'Developing a Scalable List Scrubbing Service: A Custom Web Application on Azure',
    description: `### Overview
Developed a robust list scrubbing web application for Mike Murray that integrated into an existing WordPress site. The system processed large CSV files and compared data against a massive address database, charging users per match.

### The Challenge
Mike needed a scalable service to handle 400,000+ records with real-time list comparison and transparent billing.

### Our Solution
- **Tech Stack**: .NET, Azure SQL, Entity Framework, React TypeScript, Material UI.
- **Integration**: Embedded into WordPress for seamless experience.
- **Key Features**:
  - CSV upload & processing
  - Advanced data matching algorithm
  - Per-hit billing model

### Impact
Delivered a high-precision, scalable system praised for ease of use and innovation. It reflects our capability to solve complex technical challenges and add real client value.`,
  },
  {
    slug: 'shopify-user-experience-hani',
    title: 'Crafting a User-Centric Shopify Experience for Enhanced E-Commerce Success',
    description: `### Project Overview

In the fast-paced world of e-commerce, creating a platform that combines user-friendly navigation with efficient functionality is key to capturing and retaining customer interest. Our project with Hani Mikhail exemplified this philosophy.

---

### Understanding Client Vision

Hani sought a visually appealing and highly navigable Shopify site tailored to customers of varying tech experience levels. This set a clear direction for development.

---

### Development Highlights

- **User-Friendly Design**: Simple layout and intuitive navigation.
- **Quality Content**: Effective use of language and visual structure.
- **Custom Features**: Tailored functionalities to enhance product engagement and conversion.

---

### Collaborative Process

Frequent feedback loops ensured alignment with Hani’s expectations and brand identity, accelerating development and improving results.

---

### Outcomes and Reflections

The final Shopify store received high praise for usability and design. It served as proof of our ability to deliver on both the technical and brand representation fronts.

---

### Looking Forward

This project underscores the value of client collaboration and Shopify’s strength as an e-commerce platform, guiding future success in digital storefront design.`,
  }
];
